import React from 'react';
import './Header.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

function Header({ user, onMenuToggle }) {
  return (
    <header className="global-header">
      <div className="header-container">
        <button className="menu-toggle" onClick={onMenuToggle}>
          <i className="bi bi-list"></i>
        </button>
        
        <div className="header-logo">
          <div className="logo-icon">
            <i className="bi bi-truck"></i>
          </div>
          <h1>ZHAFRAN TRANSPORT</h1>
        </div>
      </div>
    </header>
  );
}

export default Header;